module.exports = __webpack_public_path__ + "static/media/label.8ca594fc.svg";